import React, { useCallback, useContext, useMemo, useState } from 'react';
import { Tabs, Tab, DropdownButton, Dropdown } from 'react-bootstrap';  // Button, Form, Row, Col, Card, Accordion, Tabs, Tab, Badge, Table
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
import { IconContext } from "react-icons";
import { CSVLink } from "react-csv";
import { LanguagesContext } from "../../context/LanguagesContext";
import { getEntityFullName } from "../components/tools";

import './TeamProgressBlock.css';

export const TeamProgressBlock = ({ isLast, users, lessons, progress, csvData, ...props }) => {
    const { pageLanguage, activeLanguage } = useContext(LanguagesContext);
    const nameProp = useMemo(() => `name_${pageLanguage}`, [pageLanguage]);

    const [collapsed, setCollapsed] = useState(true);

    const getBlocks = (experience) => {
        return []
            .concat(experience.video_360.map(v => ({ name: v.name, type: "video_360" })))
            .concat(experience.video_flat.map(v => ({ name: v.name, type: "video_flat" })))
            .concat(experience.quiz).map(v => ({ ...v, type: "quiz" }));
    }

    const getProgressValueRender = (user, lesson, experience) => {

        let blocks = getBlocks(experience);
        let groupedCurrentProgress = progress.reduce((acc, p) => {
            if (
                p.user_id === user.id && p.lesson_id === lesson.id &&
                p.experience_id === experience.id && experience[p.block_type].some(e => e.id === p.block_id)
            ) {
                acc[p.user_temp_pass_id] = [...(acc[p.user_temp_pass_id] || []), p];
            }

            return acc;
        }, {});

        return Object.entries(groupedCurrentProgress).map(([tempPass, currentProgress]) => {
            const key = `${user.id}-${tempPass}`;

            if (blocks.length === 0 || currentProgress.length === 0)
                return <div key={key}>  </div>;
    
            let value = currentProgress.length / blocks.length;
            let teamUserText = +tempPass ? `(Team user - ${tempPass})` : '';
    
            if (value >= 1)
                return <div key={key}> complete {teamUserText}</div>;
    
            let reason = blocks[currentProgress.length];
            return (
                <div key={key}>
                    {Math.round(value * 100)}% - next: {reason.name + '/' + reason.type} {teamUserText}
                </div>
            );
        });
    }


    return (
        <div className={`team-progress-block mb-${isLast ? 3 : 1}`}>
            <div className="team-progress-block-header" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? <FaCaretRight /> : <FaCaretDown />}
                <span className="ml-2"><span className="font-weight-bold">Team: </span>{props[nameProp] || getEntityFullName(props, activeLanguage)}</span>
                <div className="ml-auto">
                    <span><span className="font-weight-bold">Users: </span>{users.length}</span>
                    <CSVLink onClick={e => e.stopPropagation()} data={csvData} className="download-data d-inline-block w-auto p-0 pl-2"
                        filename={new Date().toISOString().split('.')[0] + "-team(" + (props[nameProp] || getEntityFullName(props, activeLanguage)) + ")-answers.csv"}>
                        <span className="download-data-title">Download Data</span>
                    </CSVLink>
                </div>
            </div>
            {collapsed ? null :
                <div className="team-progress-block-body">
                    {lessons.length ? lessons.map((lesson, index) => (
                        <div className={index === lessons.length - 1 ? null : 'mb-3'} key={lesson.id}>
                            <div><span className="font-weight-bold">Lesson:</span> {lesson?.[nameProp] || getEntityFullName(lesson, activeLanguage)}</div>
                            <table className="Table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        {
                                            lesson.experiences.map((experience, index) => {
                                                return <th key={index}>{experience[nameProp] || getEntityFullName(experience, activeLanguage)}</th>
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        users.length ?
                                            users.map((user, index) => {
                                                return <tr key={index}>
                                                    <td className="border-cell"><b>{user.nickname || user.email}</b></td>
                                                    {
                                                        lesson.experiences.map((experience, index) => (
                                                            <td key={index} className="border-cell">
                                                                {getProgressValueRender(user, lesson, experience)}
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            })
                                        : null
                                    }

                                </tbody>
                            </table>
                        </div>
                    )) : 'No active lessons' }
                </div>
            }
        </div>
    )
}
